import { all, takeLatest } from 'redux-saga/effects';

import { verifyEmailAction } from '@/redux/actions/company';
import { sendEmailAction } from '@/redux/actions/company';
import { createCheckoutSessionAction } from '@/redux/actions/company';
import { changeLicenseSeatsAction } from '@/redux/actions/company';
import { previewLicenseSeatsAction } from '@/redux/actions/company';
import { createBillingPortalSessionAction } from '@/redux/actions/company';
import { getLicensePriceAction } from '@/redux/actions/company';
import { getLicenseOverviewAction } from '@/redux/actions/company';

import { verifyEmailSaga } from './verify-email';
import { sendEmailSaga } from './send-email';
import { createCheckoutSessionSaga } from './create-checkout-session';
import { changeLicenseSeatsSaga } from './change-license-seats';
import { previewLicenseSeatsSaga } from './preview-license-seats';
import { createBillingPortalSessionSaga } from './create-billing-portal-session';
import { getLicensePriceSaga } from './get-license-price';
import { getLicenseOverviewSaga } from './get-license-overview';

export default function* root(): Generator {
  yield all([takeLatest(verifyEmailAction.request.type, verifyEmailSaga)]);
  yield all([takeLatest(sendEmailAction.request.type, sendEmailSaga)]);
  yield all([takeLatest(createCheckoutSessionAction.request.type, createCheckoutSessionSaga)]);
  yield all([takeLatest(changeLicenseSeatsAction.request.type, changeLicenseSeatsSaga)]);
  yield all([takeLatest(previewLicenseSeatsAction.request.type, previewLicenseSeatsSaga)]);
  yield all([takeLatest(createBillingPortalSessionAction.request.type, createBillingPortalSessionSaga)]);
  yield all([takeLatest(getLicensePriceAction.request.type, getLicensePriceSaga)]);
  yield all([takeLatest(getLicenseOverviewAction.request.type, getLicenseOverviewSaga)]);
}
